var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.expired && _setup.expiredAt)?_c('div',{staticClass:"course-expired-banner"},[_c('h5',[_vm._v(_vm._s(_vm.$t('courses.courseExpiredInfo', { expiredDate: _setup.formatDate(_setup.expiredAt, 'dd.MM.yyyy'), expiryDuration: _setup.expiryDuration })))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }